module.exports = __webpack_public_path__ + "static/media/ts11sj.3438c4c5.png";